module.exports = __webpack_public_path__ + "static/media/logo.708c1204.png";